import * as React from "react";
import { useWasSeenByUser } from "@grandvisionhq/analytics";
import { getProductBlockDisplayDetails } from "@grandvisionhq/fun-search";
import { useVariantSwitcher, ProductBlock } from "@grandvisionhq/lib-visuals";
import { useProductLink } from "../../../../utils/utils/use-product-link.js";
import { pushVariantClickEvent } from "../../../../DataLayer/Events/DataLayer/Events/VariantSwitcherEvents.js";
const ProductListingBlock = ({
  className,
  listingProduct,
  reimbursableLogos,
  tabIndex,
  productLocation,
  onImpression,
  onInteraction,
  isPriceSuffixEnabled,
  selectedVariant,
  tealiumAttributes
}) => {
  const { activeSku, activeVariant, handleVariantChange, consolidatedVariants } = useVariantSwitcher({
    variants: [listingProduct.masterVariant, ...listingProduct.variants],
    initialSku: selectedVariant ?? listingProduct.masterVariant.sku
  });
  const link = useProductLink(listingProduct.slug, activeSku, listingProduct.productType);
  const { wasSeen, ref } = useWasSeenByUser();
  React.useEffect(() => {
    if (wasSeen && onImpression) {
      onImpression();
    }
  }, [wasSeen]);
  const onVariantChange = (sku) => {
    const selectedVariant2 = consolidatedVariants.find((variant) => variant.sku === sku);
    if (selectedVariant2) {
      pushVariantClickEvent(selectedVariant2, listingProduct.productType);
    }
    handleVariantChange(sku);
  };
  if (!activeVariant) return null;
  const frontImage = activeVariant.images?.[0];
  const angleImage = activeVariant.images?.[1];
  const displayDetails = getProductBlockDisplayDetails({
    product: listingProduct,
    variant: activeVariant
  });
  return /* @__PURE__ */ React.createElement(ProductBlock.Outer, { className, ref, tealiumAttributes }, /* @__PURE__ */ React.createElement(ProductBlock.Inner, null, /* @__PURE__ */ React.createElement(ProductBlock.Header, null, /* @__PURE__ */ React.createElement(
    ProductBlock.Header.Left,
    {
      tag: activeVariant.tag,
      isProductReimbursable: activeVariant.isInsuranceReimbursable,
      defaultReimbursableLogo: reimbursableLogos?.default,
      alternativeReimbursableLogo: reimbursableLogos?.alternative
    }
  ), /* @__PURE__ */ React.createElement(
    ProductBlock.Header.Right,
    {
      sku: activeVariant.sku,
      tabIndex,
      productLocation
    }
  )), /* @__PURE__ */ React.createElement(ProductBlock.Details, { href: link, onClick: onInteraction, tabIndex }, /* @__PURE__ */ React.createElement(ProductBlock.Details.Heading, null, displayDetails.heading), /* @__PURE__ */ React.createElement(ProductBlock.Details.Caption, null, displayDetails.caption)), /* @__PURE__ */ React.createElement(
    ProductBlock.Images,
    {
      href: link,
      onClick: onInteraction,
      frontUrl: frontImage?.url || "",
      frontAlt: frontImage?.altTag,
      angleUrl: angleImage?.url
    }
  ), /* @__PURE__ */ React.createElement(
    ProductBlock.Pricing,
    {
      originalPrice: activeVariant.pricing.price.originalPrice,
      discountedPrice: activeVariant.pricing.price.discount?.price,
      discountLabel: activeVariant.pricing.price.discount?.description,
      discountValue: activeVariant.pricing.price.discount?.badge,
      bestPrice: activeVariant.pricing.bestPrice,
      pricePerUnit: activeVariant.pricing.pricePerUnit?.amount,
      currency: activeVariant.pricing.price.currencyCode,
      isCentAmount: activeVariant.pricing.price.isCentAmount,
      hasPriceSuffix: isPriceSuffixEnabled
    }
  ), /* @__PURE__ */ React.createElement(ProductBlock.Footer, null, /* @__PURE__ */ React.createElement(
    ProductBlock.Footer.Variants,
    {
      variants: consolidatedVariants,
      activeSku,
      onVariantChange,
      tabIndex
    }
  ), listingProduct.offering?.includesLenses && !isPriceSuffixEnabled && /* @__PURE__ */ React.createElement(ProductBlock.Footer.IncludesLensesLink, { tabIndex }))));
};
export {
  ProductListingBlock
};
//# sourceMappingURL=ProductListingBlock.js.map
